/**
 * Debounce a function so it doesn't fire until waiting a set amount of time
 * @param {Function} func
 * @param {number} delay in milliseconds
 * @returns {Function}
 */
export function debounce(func, delay) {
  var timeout = null
  return function(...args) {
    clearTimeout(timeout)
    timeout = setTimeout(function() {
      func(...args)
    }, delay)
  }
}

export const preventRedirect = () => event => {
  event.preventDefault()
  event.stopPropagation()
}



// WEBPACK FOOTER //
// ./src/Utils/Functions/index.js